import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { axiosput } from "../../helpers/httprequest";
import { toast } from "react-toastify";

function GoogleSignIn({ setLogin }) {
  const handleSuccess = async (credentialResponse) => {
    const credential = credentialResponse.credential;
    const req = await axiosput("ms_applicant/loginauth", {
      token: credential,
    });
    if (req.data?.type !== undefined) {
      toast.error(req?.data?.message);
      return;
    }
    setLogin(req?.data);
  };

  const handleError = () => {
    toast.error("Login Failed");
  };

  return (
    <div>
      <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
    </div>
  );
}

export default GoogleSignIn;
